// Consume purchase fragments before analytics/provider modules initialize. This is
// a purchase lookup capability, never proof of email ownership or authentication.
let capability = '';
if (typeof window !== 'undefined' && window.location.pathname === '/checkout/setup') {
  const fragment = new URLSearchParams(window.location.hash.slice(1)).get('purchase');
  if (fragment && /^[a-f0-9]{64}$/.test(fragment)) {
    capability = fragment;
    try { sessionStorage.setItem('rill:pending-purchase', fragment); } catch { /* Keep it in memory. */ }
    window.history.replaceState(null, '', '/checkout/setup');
  }
}
export function readPurchaseCapability() {
  if (capability) return capability;
  try {
    const stored = sessionStorage.getItem('rill:pending-purchase') ?? '';
    return /^[a-f0-9]{64}$/.test(stored) ? stored : '';
  } catch { return ''; }
}

// Isolated checkout pages read the existing preference without loading an SDK.
export function purchaseAnalyticsEnabled() {
  try {
    return (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl !== true
      && !document.cookie.split(';').some(value => value.trim() === 'rill_analytics_enabled=0');
  } catch { return false; }
}
